export enum MOBILE_TOP_UP_VALIDATION {
    SUCCESS = 1,
    PRODUCT_NOT_FOUND = 8102,
    CATEGORY_NOT_FOUND = 8101,
    WRONG_PIN_ATTEMPTS = 118,
    WRONG_PIN_ATTEMPTS_SN = 5800,
}

export class MOBILE_TOPUP_PROVIDER {
    public BillerId: string;
    public Identified: boolean;
    public LogoUrl: string;
    public OperatorName: string;
    public value: string;
    public img: string;
    public text: string;
}

export enum MOBILE_TOPUP_CATEGORY {
    MOBILE = 1,
    UTITLITIES = 3,
    AIRTIME = 11,
    BUNDLE = 12,
    DATA_UTILISTIES = 13,
    ELECTRICITY = 31,
    INTERNET = 34,
    TELEVISION = 36,
    VOIP = 37
}

export enum BUNDLE_TOPUP_CATEGORY {
    MINUTES = "1",
    SMS = "2",
    INTERNET = "3"
}
export enum BUNDLE_ICON {
    MINUTES = "minutes",
    SMS = "sms",
    INTERNET = "internet"
}

export enum TOPUP_TYPE {
    AIRTIME = 0,
    BUNDLES = 1
}



// WEBPACK FOOTER //
// ./src/model/models/mobile-topup/mobile-topup.ts